<template>
  <swiper :loop="true" :navigation="true" :modules="modules" class="mySwiper" v-if="adData && adData.length">
    <swiper-slide v-for="(item, index) in adData" :key="index">
      <a :href="item.url" target="_blank" class="cursor-pointer" v-if="item.url">
        <img :src="item.image_url" class="object-contain w-full h-auto" :alt="item.name">
      </a>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  props: {
    adData: {
      type: Array,
      required: true,
    },
  },

  setup () {
    const handleSwiperInit = (swiper) => {
      console.log('Swiper instance:', swiper)
    }

    const handleSlideChange = () => {
      console.log('Slide changed')
    }

    return {
      handleSwiperInit,
      handleSlideChange,
      modules: [Navigation]
    }
  }
}
</script>